/* KOSMOPROJEKTOR — shared front-end behaviour (loaded once, deferred) */
(function () {
  function headerOffset() {
    var h =
      document.getElementById("header-group") ||
      document.querySelector(".header-wrapper, header");
    if (!h) return 0;
    var pos = window.getComputedStyle(h).position;
    return pos === "sticky" || pos === "fixed"
      ? Math.round(h.getBoundingClientRect().height)
      : 0;
  }

  /* Smooth-scroll in-page links to a section anchor (#shopify-section-…) or any
     link that opts in with data-kosmo-scroll. Delegated so it covers every
     current and future Kosmo section without per-section wiring. */
  document.addEventListener(
    "click",
    function (e) {
      var link = e.target.closest && e.target.closest('a[href^="#"]');
      if (!link) return;
      var href = link.getAttribute("href");
      if (!href || href.length < 2) return;

      var id = decodeURIComponent(href.slice(1));
      if (!/^shopify-section-/.test(id) && !link.hasAttribute("data-kosmo-scroll")) return;

      var target = document.getElementById(id);
      if (!target) return;

      e.preventDefault();
      var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      target.style.scrollMarginTop = headerOffset() + 12 + "px";
      target.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
    },
    false
  );
})();
